export default __webpack_public_path__ + "static/media/Menu.082e2ea0.svg";